<template>
  <div>
    <b-modal :active.sync="show" has-modal-card>
      <form action="">
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head is-bg-primary">
            <p class="modal-card-title has-text-white">Mahasiswa Wali <span v-if="!isEmpty(account)"> - {{ account.name }}</span></p>
          </header>
          <section class="modal-card-body">
            <b-field label="Periode">
              <b-select placeholder="Pilih periode" v-model="periode_guidance">
                <option
                  v-for="(periode, key) in periode_guidance_collection"
                  :value="periode.id"
                  :key="key">
                  {{ periode.name }}
                </option>
              </b-select>
            </b-field>

            <b-table v-if="!isEmpty(data_guidance)" :data="data_guidance">
              <template slot-scope="props">
                <b-table-column field="nama" label="Mahasiswa">
                  <p class="title" style="font-size: 15px;">{{ props.row.nama }}</p>
                  <p class="subtitle" style="font-size: 14px; margin-bottom: 3px;">{{ props.row.nim }}</p>
                  <p class="subtitle" style="font-size: 14px;">{{ props.row.jk == 'M' ? 'Laki - laki' : 'Perempuan' }}</p>
                </b-table-column>

                <b-table-column field="jurusan" label="Jurusan">
                  {{ props.row.jurusan }}
                </b-table-column>
              </template>
            </b-table>
          </section>
          <footer class="modal-card-foot">
          </footer>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { ACCOUNT } from '~/consts';

export default {
  props: {
    account: {
      type: Object,
      default: null
    },
    onHide: {
      type: Function,
      default: () => {}
    }
  },

  computed: {
    nip() {
      if (!this.isEmpty(this.account)) {
        return this.account.userUniversityId
      }

      return null;
    },
    periode_guidance_collection() {
      return collect(this.getDefaultPeriods()).map((i) => {
        return {
          id: i.value,
          name: i.text
        }
      }).toArray()
    },
    data_guidance() {
      if (!this.isEmpty(this.guidance)) {
        return this.guidance;
      }

      return [];
    },
    show: {
      get() {
        return !this.isEmpty(this.nip) ? true : false
      },
      set() {
        this.onHide();
      }
    }
  },

  watch: {
    account(val) {
      if (!this.isEmpty(val)) {
        this.getData()
      } else {
        this.guidance = [];
        this.periode_guidance = null
      }
    },
    periode_guidance(val) {
      if (!this.isEmpty(val)) {
        this.getData()
      }
    }
  },

  data() {
    return {
      periode_guidance: null,
      guidance: [],
    }
  },

  methods: {
    getData() {
      const vm = this;

      this.$axios.post(ACCOUNT.GET_GUIDANCE(this.periode_guidance), {
        isDefault: 0,
        user_university_id: this.nip,
        university_id: this.account.universityId
      }).then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          vm.guidance = data.data;
        } else {
          this.$buefy.toast.open(data.applicationSystem.message);
        }
      }).catch(({ response }) => {
      })
    }
  }
}
</script>

<style>

</style>
